import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=0ba648ce&scoped=true&"
import script from "./Ordenes.vue?vue&type=script&lang=js&"
export * from "./Ordenes.vue?vue&type=script&lang=js&"
import style0 from "./Ordenes.vue?vue&type=style&index=0&id=0ba648ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba648ce",
  null
  
)

export default component.exports